import React from 'react'
import LayoutMain from '../layouts/LayoutMain'
import MyBlock from '../UI/block/MyBlock'
import { Link } from 'react-router-dom'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

const Tasks = () => {
  return (
    <LayoutMain>
		<MyBlock>
			<ul className='submenuTop'>
				<li>
					<Link 
						to='#test'
						className='active'
					>
						<FormatListBulletedIcon />
						<span>Список задач</span>
					</Link>
				</li>
				<li>
					<Link to='#test'>
						<FormatListBulletedIcon />
						<span>Список задач</span>
					</Link>
				</li>
			</ul>
		</MyBlock>
		<MyBlock>
			<h2>Задачі людини</h2>
		</MyBlock>
    </LayoutMain>
  )
}

export default Tasks